require('./fetch-browser')
module.exports = window.Response
